import { Injectable } from "@angular/core";
import { GetClubWS } from "@app/core/club/data/network/get-clubs.ws";
import { ClubRepo } from "@app/core/club/domain/club.repo";
import { Club } from "@app/core/club/domain/model/club";

import { Observable } from "rxjs";

@Injectable()
export class ClubDataRepo implements ClubRepo {
  constructor(private getClubsWS: GetClubWS) {}

  getClubs(token: string): Observable<Club[]> {
    return this.getClubsWS.execute(token);
  }
}
